module.exports = __webpack_public_path__ + "c6d6f81dd2700573e2754c0c552f370f.svg";